/**
 * HF can show multiple system/maintenance notices right below the website header.
 * A user can use a close button to dismiss these messages.
 * We must be able to show new/changed messages to the user, though.
 * For that, we store a string containing all uids and timestamps of the messages in a cookie.
 */

import createCookie from '../Helpers/createCookie';
import readCookie from '../Helpers/readCookie';

document.addEventListener('DOMContentLoaded', function () {
    const sysNoticeGroup = document.getElementById('js_system-notice-group'),
        sysNoticeBtn = document.getElementById('js_system-notice-dismiss'),
        sysNotices = document.querySelectorAll('.js_system-notice'),
        sysNoticeCookie = readCookie('system_notices');

    // Store all notices in an array:
    let noticeArray = [];
    for (let i = 0; i < sysNotices.length; i++) {
        noticeArray.push(sysNotices[i].dataset.noticeId);
    }

    if (compareCookieWithCurrentNotices(sysNoticeCookie, noticeArray)) {
        // Immediately hide the notices if cookie is set and matches:
        sysNoticeGroup.style.display = 'none';
    }

    if (sysNoticeBtn !== null) {
        sysNoticeBtn.addEventListener('click', closeSysNoticesByButton);
    }

    /**
     * Check if all current notices are included in the cookie data.
     * The following cases will return TRUE:
     * - All active notices are present in the cookie data (regardless of array order).
     * - Some notices might no longer be active, but still stored in the cookie.
     *   This is okay, as long as the remaining notices were already dismissed by the user.
     * - Active notices were rearranged by an editor (again, order is not important).
     *
     * The following cases will return FALSE:
     * - An active notice is not stored in the cookie.
     * - An active notice has a changed timestamp.
     * */
    function compareCookieWithCurrentNotices(sysNoticeCookie, noticeArray) {
        if (typeof sysNoticeCookie !== 'undefined' || sysNoticeCookie !== null) {
            let cookieData = JSON.parse(sysNoticeCookie);

            if (Array.isArray(cookieData) && Array.isArray(noticeArray)) {
                return noticeArray.every(r => cookieData.indexOf(r) >= 0);
            }
        }

        return false;
    }

    function closeSysNoticesByButton() {
        // We store the current state of notices in the cookie and hide the parent element:
        createCookie('system_notices', JSON.stringify(noticeArray), 7);
        sysNoticeGroup.style.display = 'none';
    }
});
